import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import i18n from 'i18n-js';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';

import CategoryIcon from '@mui/icons-material/Category';
import CloseIcon from '@mui/icons-material/Close';
import LinkIcon from '@mui/icons-material/Link';
import PersonIcon from '@mui/icons-material/Person';

import { createOverlay } from '../../reducers/Builder/actions';
import { useLoginState } from '../Menu/components/LoginDialog/context';
import { AnalyticsProvider } from '../../providers';
import { BigImage, Container, SmallImage, useStyles } from './styles';

export default function TemplateDialog({ data, onClose, open }) {
  const [bigImage, setBigImage] = useState(0);
  const [loading, setLoading] = useState(false);
  const { openLoginDialog } = useLoginState();
  const user = useSelector((state) => state.user);
  const { data: userData } = user;
  const dispatch = useDispatch();
  let history = useHistory();
  const classes = useStyles();
  const smallImages =
    data && data?.images?.filter((url, index) => index !== bigImage);

  const onCloseDialog = () => {
    setBigImage(0);
    onClose();
  };
  const onClickSmallImage = (value) => {
    const index = data?.images?.findIndex((url) => url === value);
    setBigImage(index);
  };
  const onUserLoggedIn = () => {
    setLoading(true);
    AnalyticsProvider.event('CREATE_OVERLAY', { label: data.id });
    dispatch(createOverlay(data.id, history));
  };
  const onClickCreateButton = async () => {
    try {
      if (!userData.id) {
        openLoginDialog();
        return;
      }
      onUserLoggedIn();
    } catch (e) {
      console.error(e);
    }
  };
  const onClickLink = () => {
    window.open(data.link.url);
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={onCloseDialog}
        scroll="body"
      >
        <IconButton
          aria-label="close"
          onClick={onCloseDialog}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Container>
            <Box mr={4}>
              <BigImage 
                alt="overlay big" 
                key={`big-image-${bigImage}-${data?.images?.[bigImage]}`}
                src={data?.images?.[bigImage]} 
              />
              <Box mt={2}>
                <Typography gutterBottom variant="h4">
                  {data?.title}
                </Typography>
                <Typography gutterBottom variant="body1">
                  {data?.description}
                </Typography>
              </Box>
            </Box>
            <Box>
              {smallImages &&
                smallImages.map((url, index) => (
                  <SmallImage
                    alt="overlay small"
                    key={`small-image-${index}-${url}`}
                    onClick={() => onClickSmallImage(url)}
                    src={url}
                  />
                ))}
              <Box mt={2}>
                <LoadingButton
                  fullWidth
                  loading={loading}
                  onClick={onClickCreateButton}
                  variant="contained"
                >
                  {i18n.t('components.templateDialog.create')}
                </LoadingButton>
                <Box alignItems="center" display="flex" mt={3}>
                  <PersonIcon className={classes.icon} />
                  <Typography variant="body2" color="text.secondary">
                    {i18n.t('components.templateDialog.users', {
                      users: data?.users,
                    })}
                  </Typography>
                </Box>
                <Box alignItems="center" display="flex" mt={1}>
                  <CategoryIcon className={classes.icon} />
                  <Typography variant="body2" color="text.secondary">
                    {data?.category}
                  </Typography>
                </Box>
                {data?.link && (
                  <Box
                    alignItems="center"
                    display="flex"
                    mt={1}
                    onClick={onClickLink}
                  >
                    <LinkIcon className={classes.linkIcon} />
                    <Typography className={classes.link} variant="body2">
                      {data?.link?.label}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
        </DialogContent>
      </Dialog>
    </>
  );
}
